// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProfileFeed-cls1___0ccf8e0f3c2ea74210f{/*!*/}.ProfileFeed-cls2___8a87585e47475dce83d{}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ProfileFeed-cls1___0ccf8e0f3c2ea74210f",
	"cls2": "ProfileFeed-cls2___8a87585e47475dce83d ProfileFeed-cls1___0ccf8e0f3c2ea74210f"
};
export default ___CSS_LOADER_EXPORT___;
